import hatStyles from "../1-style/hatStyles";
import { findMaterialWithLabel } from "../2-material/materialUtils";
import selectAllElements from "../dom/selectAllElements";
import { clickOnDefaultSwatch } from "../utils/clickOnDefaultSwatch";
import { SWATCHES } from "./_selectors";
import setOutOfStock from "./setOutOfStock";
// import { DESCRIPTION_TEXT } from "./customizer/constants";

function disableSwatches(currentMaterialName: string) {
	const swatches = selectAllElements<HTMLSpanElement>(SWATCHES);
	const materialData = findMaterialWithLabel(hatStyles, currentMaterialName).at(0);
	console.log("materialData", currentMaterialName, materialData, hatStyles);
	// Handles size options, but we need to know if the style is fitted.
	const outOfStockSizes = materialData?.outOfStockSize;

	// Use for...of for better compatibility and performance
	for (const swatch of swatches) {
		swatch.classList.remove("out-of-stock");
		swatch.classList.add("hide");
		const val = swatch.dataset.val as string;
		if (materialData?.colors.includes(val)) {
			swatch.classList.remove("hide");
		}
		if (materialData?.outOfStock?.includes(val)) {
			setOutOfStock(swatch);
		}
	}
	const defaultSwatch = materialData?.defaultSwatch;
	console.log("defaultSwatch", defaultSwatch);
	if (defaultSwatch) {
		clickOnDefaultSwatch(defaultSwatch);
	}
}

export default disableSwatches;
